export default "__VITE_ASSET__UE_1Iz2n__"